var map = {
	"./GreyhoundRaces_light_bg.jpg": 23544,
	"./VirtualGreyhoundRaces_light_bg.jpg": 45473,
	"./VirtualHorseRaces_light_bg.jpg": 50007,
	"./VirtualMotorcycleSpeedway_light_bg.jpg": 8829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84942;